/***
 *
 *   FORGOT PASSWORD
 *   Start the password reset process.
 *
 **********/

import { Form, Link } from "components/lib";

export function ForgotPassword({ t }) {
  return (
    <div className="mb-20">
      <h1 style={{color: "white"}}>{t("auth.signin.forgotpassword.title")}</h1>
      <Form
        inputs={{
          email: {
            label: t("auth.signin.forgotpassword.form.email.label"),
            type: "email",
            required: true,
          },
        }}
        url="/api/auth/password/reset/request"
        method="POST"
        buttonText={t("auth.signin.forgotpassword.form.button")}
        redirect="/signin"
      />
      <div className="text-center mt-10">
        <Link className="text-white" url="/signin" text={t("auth.signin.forgotpassword.back_link")} />
      </div>
    </div>
  );
}
